import styled from 'styled-components'

export default styled.svg`
    width: 1em;
    transform: translateY(.2em);
`